<template>
  <div>
    <b-navbar toggleable="lg" type="dark" variant="info">
      <b-navbar-brand class="col-md-2"
        ><a href="http://www.ffbb.com" target="_blank"
          ><img src="@/assets/ffbb_hoz_blanc.png" class="nav-logo"
        /></a>
      </b-navbar-brand>
      <div class="text-left">
        <p class="nav-text">
          DEMANDE DE
          {{
            this.preinscription.data.type === "C"
              ? "CRÉATION"
              : this.preinscription.data.type === "R"
              ? "RENOUVELLEMENT"
              : this.preinscription.data.type === "M"
              ? "MUTATION"
              : ""
          }}
          DE VOTRE LICENCE
          {{ isCreation ? "" : this.preinscription.data.licence.numeroLicence }}
        </p>
        <p class="nav-text">
          DANS LE CLUB {{ this.preinscription.data.organisme.libelle }}
        </p>
      </div>
      <div class="col-md-2">
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      </div>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto">
          <!-- FAQ -->
          <b-nav-item-dropdown ref="test" @submit.stop.prevent class="nav-faq">
            <template v-slot:button-content>
              <img class="question-icon" src="@/assets/question.png" /><br />FAQ
            </template>
            <p class="text-center mt-2 tab-text-bold">
              {{ "faq_title" | translate(locale) }}
            </p>
            <div class="tablist ml-1 mr-1" role="tablist">
              <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button
                    block
                    href="#"
                    class="tab-text-normal"
                    v-b-toggle.accordion-1
                    variant="info"
                    >{{ "faq_question_1" | translate(locale) }}</b-button
                  >
                </b-card-header>
                <b-collapse
                  id="accordion-1"
                  visible
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <!-- <b-card-text
                      >I start opened because <code>visible</code> is
                      <code>true</code></b-card-text
                    > -->
                    <b-card-text class="tab-text-small">
                      <span
                        v-html="
                          $options.filters.translate(
                            'faq_reponse_question_1',
                            locale
                          )
                        "
                      ></span>
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button
                    block
                    href="#"
                    class="tab-text-normal"
                    v-b-toggle.accordion-2
                    variant="info"
                    >{{ "faq_question_2" | translate(locale) }}</b-button
                  >
                </b-card-header>
                <b-collapse
                  id="accordion-2"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text class="tab-text-small"
                      ><span
                        v-html="
                          $options.filters.translate(
                            'faq_reponse_question_2',
                            locale
                          )
                        "
                      ></span
                    ></b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button
                    block
                    href="#"
                    class="tab-text-normal"
                    v-b-toggle.accordion-3
                    variant="info"
                    >{{ "faq_question_3" | translate(locale) }}</b-button
                  >
                </b-card-header>
                <b-collapse
                  id="accordion-3"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text class="tab-text-small"
                      ><span
                        v-html="
                          $options.filters.translate(
                            'faq_reponse_question_3',
                            locale
                          )
                        "
                      ></span
                    ></b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button
                    block
                    href="#"
                    class="tab-text-normal"
                    v-b-toggle.accordion-4
                    variant="info"
                    >{{ "faq_question_4" | translate(locale) }}</b-button
                  >
                </b-card-header>
                <b-collapse
                  id="accordion-4"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text class="tab-text-small"
                      ><span
                        v-html="
                          $options.filters.translate(
                            'faq_reponse_question_4',
                            locale
                          )
                        "
                      ></span
                    ></b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button
                    block
                    href="#"
                    class="tab-text-normal"
                    v-b-toggle.accordion-5
                    variant="info"
                    >{{ "faq_question_5" | translate(locale) }}</b-button
                  >
                </b-card-header>
                <b-collapse
                  id="accordion-5"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text class="tab-text-small"
                      ><span
                        v-html="
                          $options.filters.translate(
                            'faq_reponse_question_5',
                            locale
                          )
                        "
                      ></span
                    ></b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
            <p class="tab-text-normal mt-4 ml-3 mr-3">
              {{ "nav_faq_info" | translate(locale) }}
              <a
                class="faq-a"
                href="http://www.ffbb.com/ffbb/e-licence"
                target="_blank"
                >www.ffbb.com</a
              >
            </p>
          </b-nav-item-dropdown>

          <!-- Contacter le club -->
          <b-nav-item-dropdown
            class="nav-contact"
            ref="contact"
            @hidden="erreurGlobale = null"
          >
            <template v-slot:button-content>
              <img src="@/assets/edit.png" /><br />Contacter<br />le club
            </template>
            <div>
              <div
                v-if="this.preinscription.data.formulaire.telephoneClub != null"
                class="contact-info"
              >
                <p class="tab-text-normal ml-4 mr-3 mt-2 mb-1">
                  {{ "nav_contacter_club_text" | translate(locale) }}
                </p>
                <div class="row contact-info-phone">
                  <img class="img-phone" src="@/assets/phone-forwarded.png" />
                  <p class="tab-text-bold mb-1">
                    {{ this.preinscription.data.formulaire.telephoneClub }}
                  </p>
                </div>
              </div>
              <div class="envoyer-message">
                <p class="mt-4 ml-5 tab-text-bold">
                  {{ "nav_envoyer_msg_club" | translate(locale) }}
                </p>
                <b-form-textarea
                  class="textarea-assistance"
                  placeholder="Saisissez votre message"
                  rows="6"
                  v-model="messageClub"
                  no-resize
                ></b-form-textarea>

                <div class="ml-5 mt-3 mb-3">
                  <b-button
                    variant="outline-primary"
                    :disabled="messageClub.trim() === ''"
                    @click="
                      envoyerMessage(false /*isReconnected*/, true /*club*/)
                    "
                    >{{ "nav_envoyer" | translate(locale) }}</b-button
                  >
                </div>
              </div>
              <div
                v-if="envoyerSuccessClub != null"
                class="alert alert-success text-left global-errors mb-1 ml-3 mr-3"
              >
                <p>
                  {{ envoyerSuccessClub }}
                </p>
              </div>
              <div
                v-if="erreurGlobale != null"
                class="alert alert-danger text-left global-errors mb-1 ml-3 mr-3"
              >
                <p>
                  {{ erreurGlobale }}
                </p>
              </div>
            </div>
          </b-nav-item-dropdown>

          <!-- Assistance -->
          <!--
          <b-nav-item-dropdown
            class="nav-assistance"
            ref="assistance"
            @hidden="erreurGlobale = null"
          >
            <template v-slot:button-content>
              <img class="mb-2" src="@/assets/headphones.png" /><br />Assistance
            </template>
            <div class="assistance-info">
              <p class="tab-text-normal mt-3 ml-4 mr-3">
                {{ "nav_assistance_text" | translate(locale) }}
              </p>
            </div>
            <div class="envoyer-message">
              <p class="mt-4 ml-5 tab-text-bold">
                {{ "nav_envoyer_msg_assistance" | translate(locale) }}
              </p>
              <b-form-textarea
                class="textarea-assistance"
                placeholder="Saisissez votre message"
                rows="6"
                no-resize
                v-model="messageAssistance"
              ></b-form-textarea>

              <div class="ml-5 mt-3 mb-3">
                <b-button
                  variant="outline-primary"
                  :disabled="messageAssistance.trim() === ''"
                  @click="
                    envoyerMessage(false /*isReconnected*/, false /*club*/)
                  "
                  >{{ "nav_envoyer" | translate(locale) }}</b-button
                >
              </div>
            </div>
            <div
              v-if="envoyerSuccessAssistance != null"
              class="alert alert-success text-left global-errors mb-1 ml-3 mr-3"
            >
              <p>
                {{ envoyerSuccessAssistance }}
              </p>
            </div>
            <div
              v-if="erreurGlobale != null"
              class="alert alert-danger text-left global-errors mb-1 ml-3 mr-3"
            >
              <p>
                {{ erreurGlobale }}
              </p>
            </div>
          </b-nav-item-dropdown>
          -->
          <b-nav-item class="text-center nav-item-img" href="#"
            ><img
              class="photo-img"
              :src="[
                preinscription.data.document.documentPhoto.data != null
                  ? 'data:image/gif;base64,' +
                    preinscription.data.document.documentPhoto.data
                  : require('@/assets/preinscription_photo_white.png')
              ]"
          /></b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
import preinscriptionAppelsServeur from "@/preinscriptionUtils";
import translations from "@/Translations.js";

export default {
  props: {
    preinscription: Object,
    token: undefined,
    locale: {
      type: String,
      default: "fr"
    }
  },
  data() {
    return {
      erreurGlobale: null, // valorisée dans traitementErreursServeur
      isCreation: false,
      messageAssistance: "",
      messageClub: "",
      envoyerSuccessAssistance: null,
      envoyerSuccessClub: null,
      token_out: undefined
    };
  },
  watch: {
    token: function() {
      if (this.token) {
        this.token_out = JSON.parse(JSON.stringify(this.token));
      }
    }
  },
  filters: {
    translate: function(value, locale) {
      return translations[locale][value];
    }
  },
  methods: {
    envoyerMessage(isReconnected, club) {
      var that = this;
      var contenu = club ? this.messageClub : this.messageAssistance;
      // contenu = encodeURI(contenu);
      preinscriptionAppelsServeur
        .postMessage(this.token_out, club, contenu)
        .then(result => {
          if (result.status === 200) {
            if (club) {
              that.envoyerSuccessClub = "Votre message a été envoyé";
            } else {
              that.envoyerSuccessAssistance = "Votre message a été envoyé";
            }
          }
        })
        .catch(error => {
          // a rajouter les arguments de la methode(sauf isReconnected), si necessaire ex: argsArray.push(arg1);
          var argsArray = [];
          argsArray.push(club);
          preinscriptionAppelsServeur.traitementErreursServeur(
            error,
            isReconnected,
            that,
            that.envoyerMessage,
            argsArray
          );
        });

      // this.$refs.assistance.hide();
      // this.$refs.contact.hide();
    }
  },
  created() {
    // la clone token_out est utilisée pour pouvoir mettre a jour le token si la session a expiré (on peut pas modifier directement un prop)
    if (this.token) {
      this.token_out = JSON.parse(JSON.stringify(this.token));
    }
  },
  mounted() {
    this.isCreation = this.preinscription.data.licence.id === null;
  }
};
</script>

<style scoped>
.bg-info {
  background-color: #3e5987 !important;
  height: 100%;
  min-height: 97px;
}

.navbar-brand {
  cursor: default;
}

.nav-item {
  border-left: 2px solid #69768d;
  line-height: 20px;
  background-color: #3e5987;
}

.nav-link {
  margin: 0 15px;
}

.navbar-nav {
  height: 70px;
}

.photo-img {
  height: 57px;
  width: 57px;
}

.nav-text {
  font-family: Lato;
  font-size: 16px;
  font-weight: bold;
  color: #ffffff;
  margin-bottom: 5px;
}

.navbar-collapse {
  z-index: 100;
}

.nav-item-img .nav-link {
  cursor: default;
}

.tablist .card .card-header {
  min-height: 0;
}

.tablist .btn-info {
  color: #000000;
  background-color: #f0f0f1;
  border-color: #f0f0f1;
  text-align: left;
}
.tablist .card-header {
  background-color: #f0f0f1;
  border-bottom: none;
}

.tablist .card-body {
  max-height: 150px;
  overflow-y: auto;
}

.tablist .btn-info:not(:disabled):not(.disabled):active,
.tablist .btn-info:not(:disabled):not(.disabled).active,
.show > .tablist .btn-info.dropdown-toggle {
  color: #000000;
  background-color: #f0f0f1;
  border-color: #f0f0f1;
  box-shadow: none;
}

.tablist .btn-info:focus,
.tablist .btn-info.focus {
  box-shadow: none;
}

.tab-text-bold {
  font-family: Lato;
  font-weight: bold;
  font-size: 14px;
}

.tab-text-normal {
  font-family: Lato;
  font-weight: normal;
  font-size: 14px;
}

.tab-text-small,
.textarea-assistance {
  font-family: Lato;
  font-weight: normal;
  font-size: 12px;
}

.assistance-info,
.contact-info {
  border-bottom: 1px solid #c4c4c65e;
}

.contact-info-phone {
  margin: 10px 30px;
}

.textarea-assistance {
  width: 80%;
  margin-left: 35px;
  border-radius: 12px;
  box-shadow: 0 0 9px -3px rgba(0, 0, 0, 0.1);
  border: solid 0.5px #c4c4c65e;
  display: flex;
  margin: 0 auto;
}

.envoyer-message .btn-outline-primary {
  background-color: #00822f !important;
  border-color: #00822f !important;
  width: 145px;
  height: 38px;
  border-radius: 27px !important;
  font-family: Lato;
  font-size: 13px;
  font-weight: normal;
}

.nav-logo {
  width: 128px;
  height: 51px;
  cursor: pointer;
}

.img-phone {
  width: 16px;
  height: 16px;
  margin-right: 10px;
}

.question-icon {
  width: 32px;
  height: 32px;
  margin-bottom: 2px;
}

@media (max-width: 380px) {
  .nav-text {
    font-size: 11px;
  }

  .nav-logo {
    width: 100px;
    height: 40px;
  }
}

@media (min-width: 351px) and (max-width: 1023px) {
  .nav-text {
    font-size: 13px;
  }

  .nav-logo {
    width: 100px;
    height: 40px;
  }
}

@media (min-width: 1024px) {
  .navbar-brand {
    text-align: left;
  }
}
</style>
